import React from 'react';
import { Card, CardBody, CardFooter } from 'reactstrap';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faThumbsUp,
    faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { getTimeDetails } from './TimesheetDetails';
import { getTreatAsRemoved } from './TimesheetDetail';

export default class TimesheetDetailTimeDisplay extends React.Component {
    render() {
        const { loading, timesheetDetail } = this.props;

        if (loading || !timesheetDetail) {
            return null;
        }

        if (getTreatAsRemoved(timesheetDetail)) {
            return null;
        }

        const timeDetails = getTimeDetails(timesheetDetail);

        const cardColor = timeDetails.incomplete ? 'danger' : '';

        return (
            <Card color={cardColor}>
                <CardBody
                    className={cls({
                        'text-danger':
                            timeDetails.warning && !timeDetails.incomplete,
                        'text-success':
                            !timeDetails.incomplete &&
                            timeDetails.hoursRemaining == 0,
                    })}
                >
                    {timeDetails.incomplete && <>Not Set</>}

                    {!timeDetails.incomplete &&
                        timeDetails.hoursRemaining == 0 && (
                            <FontAwesomeIcon
                                icon={faThumbsUp}
                                className="mr-2"
                            />
                        )}

                    {!timeDetails.incomplete && (
                        <>{timeDetails.hoursWorked} hrs</>
                    )}
                </CardBody>
                {!timeDetails.incomplete && timeDetails.hoursRemaining != 0 && (
                    <CardFooter>
                        {!timeDetails.incomplete &&
                            timeDetails.hoursRemaining < 0 && (
                                <FontAwesomeIcon
                                    icon={faTriangleExclamation}
                                    className="mr-2"
                                />
                            )}
                        {timeDetails.hoursRemaining} hrs left
                    </CardFooter>
                )}
            </Card>
        );
    }
}
